import {
  ErrorMessage,
  VALIDATION_MESSAGES,
} from '../models/event-content.model';

export class FormFieldValidators {
  /**
   * Valida el campo de criterio
   */
  static validateCriteria(criteriaInput: number | undefined): ErrorMessage {
    return {
      status: !criteriaInput,
      message: !criteriaInput ? VALIDATION_MESSAGES.REQUIRED_FIELD : '',
    };
  }

  /**
   * Valida el campo de observación
   */
  static validateObservation(
    observationInput: string | undefined
  ): ErrorMessage {
    if (!observationInput?.trim()) {
      return {
        status: true,
        message: VALIDATION_MESSAGES.REQUIRED_FIELD,
      };
    }

    /* if (observationInput.length < 10) {
      return {
        status: true,
        message: VALIDATION_MESSAGES.MIN_LENGTH('La observación', 10),
      };
    } */

    return { status: false, message: '' };
  }

  /**
   * Valida el campo de URL
   */
  static validateUrl(
    urlInput: string | undefined,
    isConfirmedEvaluation: boolean
  ): ErrorMessage {
    // Si no es evaluación confirmada, no validamos
    if (!isConfirmedEvaluation) {
      return { status: false, message: '' };
    }

    if (!urlInput) {
      return {
        status: true,
        message: VALIDATION_MESSAGES.REQUIRED_FIELD,
      };
    }

    try {
      new URL(urlInput);
      return { status: false, message: '' };
    } catch {
      return {
        status: true,
        message: VALIDATION_MESSAGES.INVALID_URL,
      };
    }
  }

  /**
   * Valida el campo de calificación
   */
  static validateCalification(
    calificationInput: number | undefined,
    isConfirmedEvaluation: boolean
  ): ErrorMessage {
    // Si no es evaluación confirmada, no validamos
    if (!isConfirmedEvaluation) {
      return { status: false, message: '' };
    }

    if (calificationInput === undefined) {
      return {
        status: true,
        message: VALIDATION_MESSAGES.REQUIRED_FIELD,
      };
    }

    const calification = Number(calificationInput);
    if (isNaN(calification) || calification < 0 || calification > 100) {
      return {
        status: true,
        message: VALIDATION_MESSAGES.INVALID_CALIFICATION,
      };
    }

    return { status: false, message: '' };
  }

  /**
   * Valida el campo de operador
   */
  static validateOperator(operatorInput: string | undefined): ErrorMessage {
    return {
      status: !operatorInput?.trim(),
      message: !operatorInput?.trim() ? VALIDATION_MESSAGES.REQUIRED_FIELD : '',
    };
  }
}
